'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _context = require('./context');

var _context2 = _interopRequireDefault(_context);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _weex = require('./middlewares/weex');

var _weex2 = _interopRequireDefault(_weex);

var _jsonp = require('./middlewares/jsonp');

var _jsonp2 = _interopRequireDefault(_jsonp);

var _normal = require('./middlewares/normal');

var _normal2 = _interopRequireDefault(_normal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultMiddlewares = [_weex2['default'], _jsonp2['default'], _normal2['default']];

var Puck = function () {
    function Puck() {
        _classCallCheck(this, Puck);

        this.middlewares = [].concat(defaultMiddlewares);
    }

    Puck.prototype.use = function use(fn) {
        this.middlewares.splice(this.middlewares.length - defaultMiddlewares.length, 0, fn);
        return this;
    };

    Puck.prototype.request = function request(url, options) {
        var ctx = new _context2['default'](this);
        ctx.generateRequest(url, options);
        var fn = (0, _compose2['default'])(this.middlewares);
        return new Promise(function (resolve, reject) {
            return fn(ctx).then(function () {
                var ok = ctx.res.ok;

                var response = ctx.res.createResponseEntity();
                if (ok) {
                    resolve(response);
                } else {
                    var error = new Error(response.body || response.statusText);
                    error.res = response;
                    reject(error);
                }
            }, function (error) {
                reject(error);
            });
        });
    };

    Puck.prototype.get = function get(url, options) {
        return this.request(url, _extends({}, options, {
            method: 'GET'
        }));
    };

    Puck.prototype.post = function post(url, options) {
        return this.request(url, _extends({}, options, {
            method: 'POST'
        }));
    };

    Puck.prototype.jsonp = function jsonp(url, options) {
        return this.request(url, _extends({}, options, {
            method: 'GET',
            type: 'jsonp'
        }));
    };

    return Puck;
}();

Puck.version = '1.2.3';
exports['default'] = Puck;
module.exports = exports['default'];